module.exports = __webpack_public_path__ + "static/ecohome-529351dddb5de9f8d5406a1906f86960.jpeg";